import { gql } from '@apollo/client';

export const fetchInvoicesForInvoiceGroupPage = gql`
  query fetchInvoicesForInvoiceGroupPage($id: ID!, $searchOptions: ConnectionSearchOptions) {
    invoiceGroup(id: $id) {
      id
      invoices(searchOptions: $searchOptions) {
        totalCount
        nodes {
          status
          invoiceNumber
          sourceSystem
          paymentMethod
          creditCardMaskedNumber
          dueDate
          createdDate: createdTimestamp
          grandTotal: total
          paymentCurrency
          purchaseOrderNumber
          refunds {
            id
            type
            creditNoteNumber
            sourceSystem
            total
            currency
            status
            arn
          }
          dunningStatus {
            errorCode
          }
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
  }
`;
